export class ManualConfigVariantCreateModel {
	public ComponentVariantId: number;
	public ComponentSizeId?: number;
	public ColorId?: number;
	public ComponentColorId: number;
}
